export default __webpack_public_path__ + "static/media/S.4d25f266.png";